var isObject = require('../internals/is-object');

var floor = Math.floor; // `Number.isInteger` method implementation
// https://tc39.es/ecma262/#sec-number.isinteger

module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};